import React from "react";
import styles from "./button.module.scss";
import classnames from "classnames";
import upperFirst from "lodash/upperFirst";
import type { ButtonProps, BuilderButtonProps } from "@whatslly/types/UI-V2/PageBuilderTypes";
import { Loader } from "@whatslly/ui-components/Loader";
import globalStyles from "../../v2/globalStyles";
import { Svg } from "@whatslly/ui-components/v2/BaseElements/Svg";
export const Button: React.FC<ButtonProps> = ({
  borderRadius,
  borderColor,
  fontSize,
  showBorder,
  fontWeight,
  width,
  paddingInline,
  height,
  isSubmitting,
  svg,
  className,
  children,
  primary,
  secondary,
  link,
  custom,
  testId,
  ...props
}) => {
  return (
    <button
      data-testid={testId}
      className={classnames(
        styles.buttonClass,
        globalStyles[`pi-${paddingInline ?? "large"}`],
        globalStyles[`button-height-${height ?? "default"}`],
        globalStyles[`fs-${fontSize ?? "small"}`],
        globalStyles[`fw-${fontWeight ?? "default"}`],
        globalStyles[`border-${showBorder ?? "hide"}`],
        globalStyles[`br-${borderRadius ?? "extra-large"}`],
        globalStyles[`bc-${borderColor}`],
        globalStyles[`w-${width ?? "100%"}`],
        {
          [styles.isSubmitting]: isSubmitting,
          [styles.hasSvg]: svg,
          [styles.primary]: primary || (!primary && !secondary && !link && !custom),
          [styles.secondary]: secondary,
          [styles.link]: link,
        },
        custom?.className,
        className
      )}
      {...props}
    >
      {svg && <Svg {...svg} />}
      {upperFirst(props.text)}
      {children}
      {isSubmitting && (
        <span className={styles.submitSpan}>
          <Loader scale={0.35} />
        </span>
      )}
    </button>
  );
};

export interface AnchorButtonProps
  extends Omit<BuilderButtonProps, "action" | "component">,
    React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement> {}

export const AnchorButton: React.FC<AnchorButtonProps> = ({
  borderRadius,
  borderColor,
  fontSize,
  showBorder,
  fontWeight,
  width,
  paddingInline,
  height,
  isSubmitting,
  svg,
  className,
  children,
  primary,
  secondary,
  link,
  custom,
  ...props
}) => {
  return (
    <a
      className={classnames(
        styles.buttonClass,
        globalStyles[`pi-${paddingInline ?? "large"}`],
        globalStyles[`button-height-${height ?? "default"}`],
        globalStyles[`fs-${fontSize ?? "small"}`],
        globalStyles[`fw-${fontWeight ?? "default"}`],
        globalStyles[`border-${showBorder ?? "hide"}`],
        globalStyles[`br-${borderRadius ?? "extra-large"}`],
        globalStyles[`bc-${borderColor}`],
        globalStyles[`w-${width ?? "100%"}`],
        {
          [styles.isSubmitting]: isSubmitting,
          [styles.hasSvg]: svg,
          [styles.primary]: primary || (!primary && !secondary && !link && !custom),
          [styles.secondary]: secondary,
          [styles.link]: link,
        },
        custom?.className,
        className
      )}
      {...props}
    >
      {svg && <Svg {...svg} />}
      {upperFirst(props.text)}
      {children}
      {isSubmitting && (
        <span className={styles.submitSpan}>
          <Loader scale={0.35} />
        </span>
      )}
    </a>
  );
};
